import React from 'react';
import ChipTextInput from '../components/ChipTextInput';
const AssignLicense = () => React.createElement(ChipTextInput, null);
export default AssignLicense;
